export default __webpack_public_path__ + "static/media/recurring-billing-img01.d1206bac.png";